import React from 'react'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from '@mui/icons-material/Work';

import './Resume.css'



function Resume() {
    return (
        <div id='Resume' >
            <div className='titlecontainer'>
                <h2>Resume</h2>
            </div>
            <div className='resume-description'>
                <p> This is a brief overview of my journey. With more than a year of corporate experience, I am a self-taught developer who is always improving and refining my abilities to produce creative, customer-focused solutions.
                </p>
            </div>
            <div className='education-experirence'>
                <div className='education timeline-container'>
                    <VerticalTimeline>
                        <VerticalTimelineElement
                            icon={<SchoolIcon />}
                            className="vertical-timeline-element--work"
                            iconStyle={{ background: "#ffb400", color: "#fff" }}
                        >
                            <div className="education-experirence-element">
                                <span className='Dates'>01/2024 - 04/2025(Expected)</span>
                                <h5>Masters of Science <span> -Laurentian University, Ontario, Canada</span></h5>
                                <ul>
                                    <li>Major : Computational Science</li>
                                </ul>
                            </div>
                        </VerticalTimelineElement>
                        <VerticalTimelineElement
                            icon={<WorkIcon />}
                            className="vertical-timeline-element--work"
                            iconStyle={{ background: "#ffb400", color: "#fff" }}
                        >
                            <div className="education-experirence-element">
                                <span className='Dates'>02/2023 - 04/2023</span>
                                <h5>Full Stack Developer <span> -Indian Army</span></h5>
                                <ul>
                                    <li>Worked Collaboratively with Indian Army's regiment to automate a psychometric test</li>
                                    <li>Deployed the project on time with best user experience and customer satisfaction </li>
                                    <li>Trained army officials on how to operate the software</li>
                                </ul>
                            </div>
                        </VerticalTimelineElement>
                        <VerticalTimelineElement
                            icon={<WorkIcon />}
                            className="vertical-timeline-element--work"
                            iconStyle={{ background: "#ffb400", color: "#fff" }}
                        >
                            <div className="education-experirence-element">
                                <span className='Dates'>06/2022 - 11/2023</span>
                                <h5>Full Stack Developer <span> -TechElecon Pvt. Ltd.</span></h5>
                                <ul>
                                    <li>Worked Collaboratively with 5+ departments on multiple 3+ projects while tenure</li>
                                    <li>Worked efficiently on web-applications, websites and mobile application </li>
                                    <li>Worked on high-end projects where intervention of CMD,CFO and other executives was needed</li>
                                    <li>Lead SDLC of a software as a tech-lead and got trained by project manager on leading and management  </li>
                                    <li>Trained 2 new employees on ReactJs while completely handling the backend of the software </li>
                                    <li>Managed 100+ interns' internship program efficiently</li>
                                </ul>
                            </div>
                        </VerticalTimelineElement>
                        {/* <VerticalTimelineElement
                            icon={<WorkIcon />}
                            className="vertical-timeline-element--work"
                            iconStyle={{ background: "#ffb400", color: "#fff" }}
                        >
                            <div className="education-experirence-element">
                                <span className='Dates'>03/2022 - 08/2022</span>
                                <h5>FRONTEND DEVELOPER <span> - MBIT</span></h5>
                                <ul>
                                    <li>I'm one of the developer in the team of three for developing
                                        our college new website!</li>
                                    <li>Developed responsive web pages of official site of our
                                        college new website!</li>
                                    <li>Solved the issues arrised during the development of the
                                        website!</li>
                                </ul>
                            </div>
                        </VerticalTimelineElement> */}
                        <VerticalTimelineElement
                            icon={<SchoolIcon />}
                            className="vertical-timeline-element--work"
                            iconStyle={{ background: "#ffb400", color: "#fff" }}
                        >
                            <div className="education-experirence-element">
                                <span className='Dates'>03/2022 - 04/2023</span>
                                <h5>Bachelors of Engineering<span> - GTU, Gujarat, India</span></h5>
                                <ul><li>Major : Information Technology</li></ul>
                            </div>
                        </VerticalTimelineElement>
                    </VerticalTimeline>
                </div>
            </div>
        </div>
    )
}

export default Resume